module.exports = __webpack_public_path__ + "assets/media/leo-strupczewski-light.07514472.svg";